import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  AccordionBody,
  AccordionItem,
  Form,
  Label,
  FormGroup,
  Dropdown,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  Accordion,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Alert,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  FormText,
} from "reactstrap"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { withTranslation } from "react-i18next"
import moment from "moment"
import {
  addVideoDevices,
  getVideoDevices,
  setVideoIgnoreAlarms,
} from "helpers/backend_helper"
import VideoDeviceDrawer from "./VideoDeviceDrawer"
import {
  showToast,
  stringSorter,
  downloadExcel,
  isTrue,
  dateFormatter,
  numberSorter,
  dateSorter,
  defaultPageSizeOptions,
  getOperatorByIccid,
  operatorFormatter,
  searchToURL,
  booleanSorter,
  orSeparator,
} from "utils/general"
import {
  Switch,
  Table as AntdTable,
  Input as AntdInput,
  Select,
  Form as AntdForm,
} from "antd"
import SelectOrder from "components/DropdownList/SelectOrder"
import * as Yup from "yup"
import { useFormik } from "formik"
import { tableDefaultHeight } from "constants/layout"
import { clientLinksFormatter } from "utils/tables"
import VideoDeviceHistory from "./VideoDeviceHistory"
const { Search, TextArea } = AntdInput

const VideoDevices = props => {
  const [devices, setDevices] = useState([])
  const [filteredDevices, setFilteredDevices] = useState([])
  const [activeTab, setActiveTab] = useState("1")
  const [includeTags, setIncludeTags] = useState(false)
  const [addModal, setAddModal] = useState(false)
  const [orderSettingModal, setOrderSettingModal] = useState(false)
  const [deviceHistoryModal, setDeviceHistoryModal] = useState(false)
  const [showDrawer, setShowDrawer] = useState(false)
  const [filtersOpen, setFiltersOpen] = useState("")
  const [alertsOpen, setAlertsOpen] = useState("")
  const [ongoingSearch, setOngoingSearch] = useState(false)
  const [ongoingAdd, setOngoingAdd] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [extraMenu, setExtraMenu] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [statusFilter, setStatusFilter] = useState([])
  const [modelFilter, setModelFilter] = useState([])
  const [roomStatusFilter, setRoomStatusFilter] = useState([])
  const [ignoreAlarmFilter, setIgnoreAlarmFilter] = useState()
  const [monitorConnectionFilter, setMonitorConnectionFilter] = useState()
  const [androidVersionFilter, setAndroidVersionFilter] = useState([])
  const [videoVersionFilter, setVideoVersionFilter] = useState([])
  const [monitorVersionFilter, setMonitorVersionFilter] = useState([])
  const [debuggingFilter, setDebuggingFilter] = useState()
  const [extSpeakerFilter, setExtSpeakerFilter] = useState()
  const [androidVersions, setAndroidVersions] = useState({})
  const [foundAndroidVersions, setFoundAndroidVersions] = useState([])
  const [foundVideoVersions, setFoundVideoVersions] = useState([])
  const [foundMonitorVersions, setFoundMonitorVersions] = useState([])
  const [operatorFilter, setOperatorFilter] = useState([])
  const [linkedFilter, setLinkedFilter] = useState()

  const [multilinks, setMultilinks] = useState([])
  const [duplicates, setDuplicates] = useState([])
  const [statistics, setStatistics] = useState({
    total: 0,
    shutdown: 0,
    charging: 0,
    discharging: 0,
    tabA: 0,
    tabA7: 0,
    tabA8: 0,
    tabA9: 0,
    tabA11Plus: 0,
    nokiaT21: 0,
    hmdT21: 0,
    unknownModel: 0,
  })

  const [menu, setMenu] = useState(false) //Dropdown button state
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [title] = useState(props.t("Video devices"))

  const search = useLocation().search
  const navigate = useNavigate()
  const location = useLocation()

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = title + " | Suvanto Care"

    const searchParam = new URLSearchParams(search).get("search")
    if (searchParam && searchParam != "null") setSearchText(searchParam.trim())

    abortRef.current = new AbortController()
    getDevices()
    return () => abortRef.current.abort()
  }, [])

  // Fetch devices
  useEffect(() => {
    if (includeTags) getDevices()
  }, [includeTags])

  // Clear selection when closing drawer
  useEffect(() => {
    if (!showDrawer) setSelectedRow(null)
  }, [showDrawer])

  // Calculate stats
  useEffect(() => {
    let temp = new Object()
    temp.total = devices.length
    temp.linked = devices.filter(data => data.links.length > 0).length

    temp.shutdown = devices.filter(data => data.shutdown).length
    temp.charging = devices.filter(
      data => data.isCharging && !data.shutdown
    ).length
    temp.discharging = devices.filter(
      data => !data.isCharging && !data.shutdown
    ).length

    temp.tabA = devices.filter(data =>
      data.deviceModel.includes("SM-T515")
    ).length
    temp.tabA7 = devices.filter(data =>
      data.deviceModel.includes("SM-T505")
    ).length
    temp.tabA8 = devices.filter(data =>
      data.deviceModel.includes("SM-X205")
    ).length
    temp.tabA9 = devices.filter(data =>
      data.deviceModel.includes("SM-X216B")
    ).length
    temp.tabA11Plus = devices.filter(data =>
      data.deviceModel.includes("SM-X236B")
    ).length
    temp.nokiaT21 = devices.filter(data =>
      data.deviceModel.includes("Nokia T21")
    ).length
    temp.hmdT21 = devices.filter(data =>
      data.deviceModel.includes("HMD T21")
    ).length
    temp.unknownModel = devices.filter(
      data => !data.deviceModel || data.deviceModel.length == 0
    ).length

    setStatistics(temp)
  }, [devices])

  // Check duplicate values
  useEffect(() => {
    if (devices) {
      // ICCID, IMEI, TEAMVIEWER
      let dups = []
      for (let i = 0; i < devices.length - 1; i++) {
        for (let j = i + 1; j < devices.length; j++) {
          if (devices[i].iccid && devices[i].iccid === devices[j].iccid) {
            dups.push({
              key: devices[i].iccid,
              name: "ICCID:" + devices[i].iccid,
            })
          }
          if (devices[i].imei && devices[i].imei === devices[j].imei) {
            dups.push({ key: devices[i].imei, name: "IMEI:" + devices[i].imei })
          }
          if (
            devices[i].teamViewerId &&
            devices[i].teamViewerId === devices[j].teamViewerId
          ) {
            dups.push({
              key: devices[i].teamViewerId,
              name: "TVID:" + devices[i].teamViewerId,
            })
          }
        }
      }
      setDuplicates(dups)
    }
  }, [devices])

  // Check multiple links
  useEffect(() => {
    if (devices) {
      let multis = []
      for (const element of devices) {
        if (element.links.length > 1) {
          multis.push({ key: element.serial, name: element.serial })
        }
      }
      setMultilinks(multis)
    }
  }, [devices])

  // Hide alerts if no content
  useEffect(() => {
    if (multilinks.length == 0 && duplicates.length == 0) setAlertsOpen("")
  }, [multilinks, duplicates])

  // Search or filter changed
  useEffect(() => {
    handleSearch()
  }, [
    searchText,
    statusFilter,
    devices,
    roomStatusFilter,
    ignoreAlarmFilter,
    modelFilter,
    monitorConnectionFilter,
    androidVersionFilter,
    videoVersionFilter,
    monitorVersionFilter,
    debuggingFilter,
    extSpeakerFilter,
    operatorFilter,
    linkedFilter,
  ])

  // Handle search function
  const handleSearch = () => {
    //console.log("search: ", ignoreAlarmFilter)
    const searchTextLowercase = (searchText || "").toLowerCase()
    const terms = searchTextLowercase
      .split(orSeparator)
      .map(p => p.trim())
      .filter(Boolean)

    const result = devices.filter(data => {
      const status =
        statusFilter?.length == 0 ||
        (statusFilter.includes("0") && !data.shutdown) ||
        (statusFilter.includes("1") && data.isCharging && !data.shutdown) ||
        (statusFilter.includes("2") && !data.isCharging && !data.shutdown) ||
        (statusFilter.includes("3") && data.shutdown)

      const monitorConn =
        !monitorConnectionFilter ||
        (monitorConnectionFilter === "connected" &&
          data.lastConnectedDiff <= 30) ||
        (monitorConnectionFilter === "disconnected" &&
          (data.lastConnectedDiff == null || data.lastConnectedDiff > 30))

      const model =
        modelFilter?.length == 0 ||
        (modelFilter.includes("undefined") && !data.deviceModel) ||
        modelFilter?.includes(data.deviceModelLite)

      const flags =
        (ignoreAlarmFilter == undefined ||
          ignoreAlarmFilter == data.ignoreAlarms) &&
        (debuggingFilter == undefined || debuggingFilter == data.debugging) &&
        (extSpeakerFilter == undefined ||
          extSpeakerFilter == data.externalSpeaker)

      const room =
        roomStatusFilter?.length == 0 ||
        (roomStatusFilter.includes("off15") &&
          data.roomStatus == 0 &&
          data.roomConnectedDiff > 15) ||
        roomStatusFilter?.includes(data.roomStatus)

      const versions =
        (androidVersionFilter?.length == 0 ||
          androidVersionFilter?.includes(data.androidVersion)) &&
        (videoVersionFilter?.length == 0 ||
          videoVersionFilter?.includes(data.videoVersion)) &&
        (monitorVersionFilter?.length == 0 ||
          monitorVersionFilter?.includes(data.monitorVersion))

      const operator =
        operatorFilter?.length == 0 || operatorFilter?.includes(data.operator)

      const linked =
        !linkedFilter ||
        (linkedFilter === "1" && data.links.length > 0) ||
        (linkedFilter === "2" && data.links.length == 0)

      // Jos includeTags(Hae tunnisteet) on päällä, niin ei sisällytetä linkedNames
      const textMatch =
        terms.length == 0
          ? true
          : terms.some(t =>
              includeTags
                ? data.serial?.toLowerCase().includes(t) ||
                  data.imei?.toLowerCase().includes(t) ||
                  data.iccid?.toLowerCase().includes(t) ||
                  data.teamViewerId?.toLowerCase().includes(t) ||
                  data.deviceModel?.toLowerCase().includes(t) ||
                  data.buildNumber?.toLowerCase().includes(t) ||
                  data.orderNumber?.toLowerCase().includes(t) ||
                  data.groupTags?.toLowerCase().includes(t) ||
                  data.roomName?.toLowerCase().includes(t) ||
                  data.videoVersion?.includes(t)
                : data.serial?.toLowerCase().includes(t) ||
                  data.imei?.toLowerCase().includes(t) ||
                  data.iccid?.toLowerCase().includes(t) ||
                  // data.operator?.toLowerCase().includes(searchTextLowercase) ||
                  data.teamViewerId?.toLowerCase().includes(t) ||
                  data.deviceModel?.toLowerCase().includes(t) ||
                  data.buildNumber?.toLowerCase().includes(t) ||
                  data.orderNumber?.toLowerCase().includes(t) ||
                  data.groupTags?.toLowerCase().includes(t) ||
                  data.linkedNames?.toLowerCase().includes(t) ||
                  data.roomName?.toLowerCase().includes(t) ||
                  data.videoVersion?.includes(t)
            )

      return (
        status &&
        monitorConn &&
        model &&
        flags &&
        room &&
        versions &&
        operator &&
        linked &&
        textMatch
      )
    })

    setFilteredDevices(result)
  }

  // Get video devices list
  const getDevices = () => {
    setOngoingSearch(true)

    // Create a timeout promise
    const timeoutPromise = new Promise(resolve => {
      setTimeout(() => {
        resolve({ timeout: true })
      }, 120000)
    })

    Promise.race([
      getVideoDevices(abortRef.current, includeTags, false),
      timeoutPromise,
    ])
      .then(result => {
        if (result.timeout) {
          console.log("Timeout: The operation took too long.")
        } else if (result.statusCode === 200 && result.entries != null) {
          //console.log(result)
          let now = moment()
          let sysVersions = {}
          let androidv = []
          let videoVer = []
          let monitorVer = []
          for (const element of result.entries) {
            // Room status description
            switch (element.roomStatus) {
              case 0:
                element.statusDescription = "Offline"
                break
              case 1:
                element.statusDescription = "Online"
                break
              case 2:
                element.statusDescription = "Call"
                break
              case 3:
                element.statusDescription = "Group"
                break
              default:
                element.statusDescription = ""
                break
            }

            // Simplified model for filtering
            element.deviceModelLite = element.deviceModel
            if (element.deviceModel?.includes("SM-T515"))
              element.deviceModelLite = "SM-T515"
            else if (element.deviceModel?.includes("SM-T505"))
              element.deviceModelLite = "SM-T505"
            else if (element.deviceModel?.includes("SM-X205"))
              element.deviceModelLite = "SM-X205"
            else if (element.deviceModel?.includes("SM-X216B"))
              element.deviceModelLite = "SM-X216B"

            if (element.androidVersion) {
              // Android version counter
              sysVersions[element.androidVersion] =
                sysVersions[element.androidVersion] != null
                  ? sysVersions[element.androidVersion] + 1
                  : 1

              // Dynamic android versions filter
              if (!androidv.includes(element.androidVersion)) {
                androidv.push(element.androidVersion)
              }
            }

            if (
              element.videoVersion &&
              !videoVer.includes(element.videoVersion)
            ) {
              videoVer.push(element.videoVersion)
            }

            if (
              element.monitorVersion &&
              !monitorVer.includes(element.monitorVersion)
            ) {
              monitorVer.push(element.monitorVersion)
            }

            element.linkedNames = getLinkedNames(element.links)

            if (element.lastConnection) {
              element.lastConnectedDiff = now.diff(
                moment(element.lastConnection),
                "minutes"
              )
            } else {
              element.lastConnectedDiff = 99999
            }

            if (element.roomLastOnline) {
              element.roomConnectedDiff = now.diff(
                moment(element.roomLastOnline),
                "minutes"
              )
            } else {
              element.roomConnectedDiff = 99999
            }

            element.operator = getOperatorByIccid(element.iccid) || ""
          }

          // Android versions
          androidv.sort(function (a, b) {
            return b - a
          })
          setFoundAndroidVersions(androidv)

          // Video versions
          videoVer.sort(function (a, b) {
            return b.localeCompare(a)
          })
          setFoundVideoVersions(videoVer)

          // Monitor versions
          monitorVer.sort(function (a, b) {
            return b.localeCompare(a)
          })
          setFoundMonitorVersions(monitorVer)

          setAndroidVersions(sysVersions)
          //console.log("result.entries:", result.entries)
          setDevices(result.entries)
        } else {
          setDevices([])
        }
        setOngoingSearch(false)
      })
      .catch(err => {
        console.log(err)
        setDevices([])
        setOngoingSearch(false)
      })
  }

  // Get linked names in proper format
  const getLinkedNames = links => {
    let linkedNames = []
    if (links) {
      for (const link of links) {
        linkedNames.push(link.name)
      }
    }
    return linkedNames.join()
  }

  // Add new devices validation
  const addValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      serialList: "",
      ignoreAlarms: false,
      orderNumber: null,
    },
    validationSchema: Yup.object({
      serialList: Yup.string().required(props.t("Required field")),
    }),
    onSubmit: values => {
      console.log("Add submit: ", values)
      if (!ongoingAdd) {
        setOngoingAdd(true)
        addVideoDevices(
          abortRef.current,
          values.serialList,
          values.orderNumber,
          values.ignoreAlarms
        )
          .then(result => {
            if (result.statusCode === 200) {
              setAddModal(false)
              showToast(
                result.addCount + " " + props.t("devices added"),
                "success"
              )
              getDevices()
              addValidation.resetForm()
            } else {
              showToast(props.t("Error"), "error")
            }
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error")
          })
          .finally(() => {
            setOngoingAdd(false)
          })
      }
    },
  })

  // Set settings by order validation
  const orderSettingsValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ignoreAlarms: false,
      orderNumber: null,
    },
    validationSchema: Yup.object({
      orderNumber: Yup.string().required(props.t("Required field")),
    }),
    onSubmit: values => {
      console.log("Settings submit: ", values)
      if (!ongoingAdd) {
        setOngoingAdd(true)
        setVideoIgnoreAlarms(
          abortRef.current,
          values.orderNumber,
          values.ignoreAlarms
        )
          .then(result => {
            console.log("Set ignore result: ", result)
            if (result.statusCode === 200) {
              setOrderSettingModal(false)
              showToast(props.t("Updated"), "success")
              getDevices()
              orderSettingsValidation.resetForm()
            } else {
              showToast(props.t("Error"), "error")
            }
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error")
          })
          .finally(() => {
            setOngoingAdd(false)
          })
      }
    },
  })

  // Table structure
  const columns = [
    {
      dataIndex: "actions",
      title: props.t("Actions"),
      align: "center",
      sorter: (a, b, sortOrder) => {
        return booleanSorter(a, b, "hasRemarks", sortOrder)
      },
      render: editFormatter,
      fixed: "left",
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "serial",
      title: props.t("Serial"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "serial", sortOrder)
      },
      fixed: "left",
      width: "165px",
      ellipsis: true,
    },
    {
      dataIndex: "roomName",
      title: props.t("Number"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "roomName", sortOrder)
      },
      render: roomFormatter,
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "statusDescription",
      title: props.t("Status"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "statusDescription", sortOrder)
      },
      render: cell => {
        return cell == "Offline" ? (
          <span className="text-danger">{cell}</span>
        ) : (
          cell
        )
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "roomLastOnline",
      title: props.t("Last online"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["roomLastOnline"], b["roomLastOnline"], sortOrder)
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },
    ...(includeTags
      ? [
          {
            dataIndex: "groupTags",
            title: props.t("Tags"),
            sorter: (a, b, sortOrder) => {
              return stringSorter(a, b, "groupTags", sortOrder)
            },
            width: "120px",
            ellipsis: true,
          },
        ]
      : []),
    {
      dataIndex: "linkedNames",
      title: props.t("Links"),
      render: clientLinksFormatter,
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "linkedNames", sortOrder)
      },
      width: "400px",
      ellipsis: true,
    },
    {
      dataIndex: "lastConnection",
      title: "Monitor " + props.t("connection"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["lastConnection"], b["lastConnection"], sortOrder)
      },
      render: connectionFormatter,
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "videoVersion",
      title: "Video ver.",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "videoVersion", sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "monitorVersion",
      title: "Monitor ver.",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "monitorVersion", sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "teamViewerId",
      title: "TeamViewer ID",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "teamViewerId", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "buildNumber",
      title: props.t("Build"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "buildNumber", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "orderNumber",
      title: props.t("Order number"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "orderNumber", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "imei",
      title: props.t("IMEI"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "imei", sortOrder)
      },
      render: imeiFormatter,
      width: "145px",
      ellipsis: true,
    },
    {
      dataIndex: "iccid",
      title: props.t("ICCID"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "iccid", sortOrder)
      },
      width: "175px",
      ellipsis: true,
    },
    {
      dataIndex: "operator",
      title: props.t("Operator"),
      render: (text, record) => {
        return operatorFormatter(record.operator)
      },
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "operator", sortOrder)
      },
      width: "110px",
      ellipsis: true,
      align: "center",
    },
    {
      dataIndex: "shutdown",
      title: props.t("Shutdown"),
      align: "center",
      sorter: (a, b) => {
        return a.shutdown - b.shutdown
      },
      render: cell => {
        return cell ? <i className="mdi mdi-check-bold text-primary" /> : <></>
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "batteryLevel",
      title: props.t("Battery"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["batteryLevel"], b["batteryLevel"], sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "isCharging",
      title: props.t("Charging"),
      align: "center",
      sorter: (a, b) => {
        return a.isCharging - b.isCharging
      },
      //render: (cell) => {return String(cell)},
      render: cell => {
        return cell ? <i className="mdi mdi-check-bold text-primary" /> : <></>
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "chargingSource",
      title: props.t("Charging source"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "chargingSource", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "externalSpeaker",
      title: props.t("External speaker"),
      align: "center",
      render: cell => {
        return cell ? <i className="mdi mdi-check-bold text-primary" /> : <></>
      },
      sorter: (a, b, sortOrder) => {
        return booleanSorter(a, b, "externalSpeaker", sortOrder)
      },
      width: "110px",
      ellipsis: true,
    },
    {
      dataIndex: "availableMemory",
      title: props.t("Available memory"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["availableMemory"],
          b["availableMemory"],
          sortOrder
        )
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "screenBrightness",
      title: props.t("Brightness"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["screenBrightness"],
          b["screenBrightness"],
          sortOrder
        )
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "connectionType",
      title: props.t("Connection type"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "connectionType", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "networkType",
      title: props.t("Network"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "networkType", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "cellInfo",
      title: props.t("Cell info"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "cellInfo", sortOrder)
      },
      width: "250px",
      ellipsis: true,
    },
    {
      dataIndex: "cellSignalStrength",
      title: props.t("Cell strength"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "cellSignalStrength", sortOrder)
      },
      width: "220px",
      ellipsis: true,
    },
    /*{
      dataIndex: "bluetoothCount",
      title: props.t("BT count"),
      sorter: (a, b) => {
        return a.bluetoothCount - b.bluetoothCount
      },
      width: "120px",
      ellipsis: true,
    },*/
    {
      dataIndex: "volumeLevel",
      title: props.t("Volume"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "volumeLevel", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "videoAppConnection",
      title: "Video app " + props.t("connection"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(
          a["videoAppConnection"],
          b["videoAppConnection"],
          sortOrder
        )
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "healthAppConnection",
      title: "Health " + props.t("connection"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(
          a["healthAppConnection"],
          b["healthAppConnection"],
          sortOrder
        )
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "healthVersion",
      title: "Health ver.",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "healthVersion", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "webviewVersion",
      title: "Webview ver.",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "webviewVersion", sortOrder)
      },
      width: "180px",
      ellipsis: true,
    },
    {
      dataIndex: "chromeVersion",
      title: "Chrome ver.",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "chromeVersion", sortOrder)
      },
      width: "180px",
      ellipsis: true,
    },
    {
      dataIndex: "androidVersion",
      title: props.t("Android"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "androidVersion", sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "deviceModel",
      title: props.t("Model"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "deviceModel", sortOrder)
      },
      width: "190px",
      ellipsis: true,
    },
    {
      dataIndex: "batteryVoltage",
      title: props.t("Battery voltage"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["batteryVoltage"], b["batteryVoltage"], sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "batteryCurrentNow",
      title: props.t("Current now"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["batteryCurrentNow"],
          b["batteryCurrentNow"],
          sortOrder
        )
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "batteryCurrentAverage",
      title: props.t("Current avg"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["batteryCurrentAverage"],
          b["batteryCurrentAverage"],
          sortOrder
        )
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "batteryCapacityMah",
      title: props.t("Capacity"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["batteryCapacityMah"],
          b["batteryCapacityMah"],
          sortOrder
        )
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "chargeTime",
      title: props.t("Charge time"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "chargeTime", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "rebootSent",
      title: props.t("Reboot sent"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["rebootSent"], b["rebootSent"], sortOrder)
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "deviceStarted",
      title: props.t("Device started"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["deviceStarted"], b["deviceStarted"], sortOrder)
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },
    /*{
      dataIndex: "debugging",
      title: props.t("Debugging"),
      align: "center",
      sorter: (a, b) => {
        return a.debugging - b.debugging
      },
      render: cell => {
        return cell == true ? (
          <i className="mdi mdi-check-bold text-primary" />
        ) : (
          <></>
        )
      },
      width: "140px",
      ellipsis: true,
    },*/
    {
      dataIndex: "ignoreAlarms",
      title: props.t("Ignore alarms"),
      align: "center",
      sorter: (a, b) => {
        return a.ignoreAlarms - b.ignoreAlarms
      },
      //render: (cell) => {return String(cell)},
      render: cell => {
        return cell ? <i className="mdi mdi-check-bold text-primary" /> : <></>
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "bluetoothDeviceList",
      title: props.t("Bluetooth devices"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "bluetoothDeviceList", sortOrder)
      },
      width: "160px",
      ellipsis: true,
    },
    AntdTable.SELECTION_COLUMN,
  ]

  function editFormatter(cell, row) {
    return (
      <div className="d-inline-flex">
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => {
            setShowDrawer(true)
            setSelectedRow(row)
          }}
        >
          <i className="mdi mdi-pencil" />
          {row.hasRemarks && (
            <i className="mdi mdi-alert-circle text-danger ms-1" />
          )}
        </Button>
        <Button
          className="ms-2"
          color="primary"
          outline
          size="sm"
          onClick={() => {
            copyToClipboard(row)
          }}
        >
          <i className="mdi mdi-clipboard-edit" />
        </Button>
        {row.debugging && (
          <Button
            className="ms-2"
            color="primary"
            outline
            size="sm"
            onClick={() => {
              setSelectedRow(row)
              setDeviceHistoryModal(true)
            }}
          >
            <i className="mdi mdi-history" />
          </Button>
        )}
      </div>
    )
  }

  function connectionFormatter(value, row) {
    if (!value) return ""
    let dateString = moment(value).format("DD.MM.YYYY HH:mm:ss")

    if (row.lastConnectedDiff == null || row.lastConnectedDiff > 30) {
      return <span className="text-danger">{dateString}</span>
    } else return dateString
  }

  function roomFormatter(cell, row) {
    if (row.roomName && row.roomName.length > 0) {
      return (
        <Link
          to={"/config/video-numbers?search=" + row.roomName}
          target="_blank"
        >
          <span>{row.roomName}</span>
        </Link>
      )
    }
  }

  function imeiFormatter(cell, row) {
    if (
      row.imei &&
      (row.serial.startsWith("PP") || row.serial.startsWith("EH"))
    ) {
      return (
        <a
          href={"https://console.hmdenablepro.com/devices?q=" + row.imei.trim()}
          target="_blank"
          rel="noreferrer"
        >
          {row.imei}
        </a>
      )
    } else return cell
  }

  // Copy video info to clipboard
  const copyToClipboard = row => {
    let text = row.serial + ", " + row.roomName
    text = text + ", Video ver." + row.videoVersion
    //text = text + ", Health ver." + row.healthVersion
    text = text + ", Monitor ver." + row.monitorVersion
    text = text + ", Koontiver." + row.buildNumber
    text = text + ", Webview ver." + row.webviewVersion
    text = text + ", Chrome ver." + row.chromeVersion

    text = text + ", Linkit:"
    for (const element of row.links) {
      text = text + " " + element.name
    }

    text =
      text +
      ", Video yhteys " +
      moment(row.videoAppConnection).format("DD.MM.YYYY HH:mm:ss")
    text =
      text +
      ", Yhteys " +
      moment(row.lastConnection).format("DD.MM.YYYY HH:mm:ss")
    text =
      text +
      ", Käynnistynyt " +
      moment(row.deviceStarted).format("DD.MM.YYYY HH:mm:ss")
    text = text + ", Android " + row.androidVersion
    text = text + ", Malli " + row.deviceModel
    text = text + ", Operaattori " + row.operator
    text = text + ", Latauksessa " + row.isCharging
    text = text + ", Verkko " + row.networkType
    text = text + ", Solun taso " + row.cellSignalStrength

    navigator.clipboard.writeText(text)
    showToast(props.t("Copied to clipboard"), "info")
  }

  // Export values
  const generateExcel = () => {
    const heading = [
      [
        props.t("Serial"),
        props.t("Number"),
        props.t("Status"),
        props.t("Last online"),
        ...(includeTags ? [props.t("Tags")] : []),
        props.t("Links"),
        "Monitor " + props.t("connection"),
        "Video ver.",
        "Monitor ver.",
        "TeamViewer ID",
        props.t("Build"),
        props.t("Order number"),
        props.t("IMEI"),
        props.t("ICCID"),
        props.t("Operator"),
        props.t("Ignore alarms"),
        props.t("Shutdown"),
        props.t("Battery"),
        props.t("Charging"),
        props.t("Charging source"),
        props.t("Available memory"),
        props.t("Brightness"),
        props.t("Connection type"),
        props.t("Network"),
        props.t("Signal strength"),
        props.t("Cell info"),
        props.t("Cell strength"),
        //props.t("BT count"),
        props.t("Volume"),
        "Video app " + props.t("connection"),
        "Health " + props.t("connection"),
        "Health ver.",
        "Webview ver.",
        "Chrome ver.",
        props.t("Android"),
        props.t("Model"),
        props.t("Battery voltage"),
        props.t("Current now"),
        props.t("Current avg"),
        props.t("Capacity"),
        props.t("Charge time"),
        props.t("Reboot sent"),
        props.t("Device started"),
        props.t("Bluetooth devices"),
      ],
    ]
    const data = filteredDevices.map(elt => {
      return [
        elt.serial,
        elt.roomName,
        elt.statusDescription,
        dateFormatter(elt.roomLastOnline),
        ...(includeTags ? [elt.groupTags] : []),
        elt.linkedNames,
        dateFormatter(elt.lastConnection),
        elt.videoVersion,
        elt.monitorVersion,
        elt.teamViewerId,
        elt.buildNumber,
        elt.orderNumber,
        elt.imei,
        elt.iccid,
        elt.operator,
        isTrue(elt.ignoreAlarms),
        isTrue(elt.shutdown),
        elt.batteryLevel,
        isTrue(elt.isCharging),
        elt.chargingSource,
        elt.availableMemory,
        elt.screenBrightness,
        elt.connectionType,
        elt.networkType,
        elt.gsmSignalStrength,
        elt.cellInfo,
        elt.cellSignalStrength,
        //elt.bluetoothCount,
        elt.volumeLevel,
        dateFormatter(elt.videoAppConnection),
        dateFormatter(elt.healthAppConnection),
        elt.healthVersion,
        elt.webviewVersion,
        elt.chromeVersion,
        elt.androidVersion,
        elt.deviceModel,
        elt.batteryVoltage,
        elt.batteryCurrentNow,
        elt.batteryCurrentAverage,
        elt.batteryCapacityMah,
        elt.chargeTime,
        dateFormatter(elt.rebootSent),
        dateFormatter(elt.deviceStarted),
        elt.bluetoothDeviceList,
      ]
    })

    downloadExcel(title, heading, data)
    showToast(props.t("Excel file exported succesfully!"), "success")
  }

  // Table selection changed
  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={props.t("Video devices")} />
          <Row>
            <Col>
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <div className="d-flex flex-wrap">
                    <ul className="nav nav-tabs nav-tabs-custom card-header-tabs">
                      <NavItem>
                        <NavLink
                          to="#"
                          active={activeTab === "1"}
                          onClick={() => {
                            setActiveTab("1")
                          }}
                        >
                          {props.t("Table")}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          active={activeTab === "2"}
                          onClick={() => {
                            setActiveTab("2")
                          }}
                        >
                          {props.t("Statistics")}
                        </NavLink>
                      </NavItem>
                    </ul>
                  </div>
                </CardHeader>
                <CardBody>
                  <TabContent activeTab={activeTab}>
                    <TabPane className="show" tabId="1">
                      <Accordion
                        flush
                        open={alertsOpen}
                        toggle={id => {
                          id === alertsOpen
                            ? setAlertsOpen("")
                            : setAlertsOpen(id)
                        }}
                      >
                        <AccordionItem>
                          <AccordionBody
                            accordionId="1"
                            className="accordion-zeropadding"
                          >
                            <Alert color="danger">
                              <div>
                                <h5 className="alert-heading">
                                  {props.t("Duplicate values")}
                                </h5>
                                {duplicates.map((entry, index) => (
                                  <Button
                                    size="sm"
                                    color="danger"
                                    outline
                                    key={"" + index}
                                    className="me-2 mb-2"
                                    onClick={() => {
                                      setSearchText(entry.key)
                                    }}
                                  >
                                    <span>{entry.name}</span>
                                  </Button>
                                ))}
                              </div>
                              <div>
                                <h5 className="alert-heading">
                                  {props.t("Multiple links")}
                                </h5>
                                {multilinks.map((entry, index) => (
                                  <Button
                                    size="sm"
                                    color="danger"
                                    outline
                                    key={"" + index}
                                    className="me-2 mb-2"
                                    onClick={() => {
                                      setSearchText(entry.key)
                                    }}
                                  >
                                    <span>{entry.name}</span>
                                  </Button>
                                ))}
                              </div>
                            </Alert>
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                      <Row>
                        <Col>
                          {devices != null && (
                            <React.Fragment>
                              <Row className="mb-1">
                                <Col
                                  className="mb-3"
                                  style={{ maxWidth: "320px" }}
                                >
                                  <Search
                                    placeholder={props.t("Search")}
                                    allowClear
                                    value={searchText}
                                    onChange={event => {
                                      setSearchText(event.target.value)
                                    }}
                                    onBlur={() =>
                                      // Apply search word to URL
                                      searchToURL(
                                        searchText,
                                        location,
                                        navigate
                                      )
                                    }
                                    style={{ minWidth: "240px" }}
                                  />
                                </Col>
                                <Col className="col-auto">
                                  <Button
                                    color="primary"
                                    className="compact-button"
                                    id="filter-button"
                                    outline
                                    onClick={() => {
                                      filtersOpen.length > 0
                                        ? setFiltersOpen("")
                                        : setFiltersOpen("1")
                                    }}
                                  >
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="filter-button"
                                    >
                                      {props.t("Filters")}
                                    </UncontrolledTooltip>
                                    {filtersOpen ? (
                                      <i className="mdi mdi-filter-minus"></i>
                                    ) : (
                                      <i className="mdi mdi-filter-menu"></i>
                                    )}
                                  </Button>
                                  <Button
                                    className="compact-button ms-3"
                                    color="primary"
                                    disabled={ongoingSearch}
                                    onClick={() => {
                                      getDevices()
                                    }}
                                  >
                                    <i className="mdi mdi-refresh me-2" />
                                    {props.t("Refresh")}
                                  </Button>
                                  <Button
                                    className="compact-button ms-3"
                                    color="success"
                                    onClick={() => {
                                      setAddModal(true)
                                    }}
                                  >
                                    <i className="mdi mdi-plus me-2" />
                                    {props.t("Add devices")}
                                  </Button>
                                  <ButtonDropdown
                                    className="ms-3"
                                    isOpen={extraMenu}
                                    toggle={() => {
                                      setExtraMenu(!extraMenu)
                                    }}
                                  >
                                    <DropdownToggle
                                      color="primary"
                                      className="compact-button"
                                      caret
                                    >
                                      <i className="mdi mdi-menu me-2" />
                                      {props.t("Other actions")}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem
                                        onClick={() => {
                                          setOrderSettingModal(true)
                                        }}
                                      >
                                        {props.t("Set ignore alarms")}
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </ButtonDropdown>
                                  {(duplicates.length > 0 ||
                                    multilinks.length > 0) && (
                                    <Button
                                      color="danger"
                                      className="compact-button ms-3"
                                      id="alerts-button"
                                      onClick={() => {
                                        alertsOpen.length > 0
                                          ? setAlertsOpen("")
                                          : setAlertsOpen("1")
                                      }}
                                    >
                                      <UncontrolledTooltip
                                        placement="bottom"
                                        target="alerts-button"
                                      >
                                        {props.t("Notices")}
                                      </UncontrolledTooltip>
                                      {alertsOpen ? (
                                        <i className="mdi mdi-alert-minus"></i>
                                      ) : (
                                        <i className="mdi mdi-alert-plus"></i>
                                      )}
                                    </Button>
                                  )}
                                </Col>
                                <Col className="mt-1 col-auto">
                                  <FormGroup>
                                    <Switch
                                      id="includeTagsSwitch"
                                      name="includeTags"
                                      checked={includeTags}
                                      disabled={ongoingSearch}
                                      onChange={v => {
                                        setIncludeTags(v)
                                      }}
                                      checkedChildren={
                                        <div
                                          className="d-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <i
                                            className="bx bx-tag font-size-16"
                                            style={{ marginTop: "3px" }}
                                          />
                                        </div>
                                      }
                                      unCheckedChildren={
                                        <div
                                          className="d-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <i
                                            className="bx bx-tag font-size-16"
                                            style={{ marginTop: "3px" }}
                                          />
                                        </div>
                                      }
                                    ></Switch>
                                    <UncontrolledTooltip
                                      placement="right"
                                      target="includeTagsSwitch"
                                    >
                                      {props.t("Search tags")}
                                    </UncontrolledTooltip>
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <span className="float-end ms-2">
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="downloadstatstable"
                                    >
                                      {props.t("Download statistics")}
                                    </UncontrolledTooltip>
                                    <Dropdown
                                      id="printButtonServicesStats"
                                      isOpen={menu}
                                      toggle={() => setMenu(!menu)}
                                      className="download-btn text-center"
                                      type="button"
                                    >
                                      <DropdownToggle
                                        id="downloadstatstable"
                                        className="text-muted"
                                        tag="i"
                                      >
                                        <i className="mdi mdi-download" />
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={() => generateExcel()}
                                        >
                                          {props.t("Download .xlsx")}
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </Dropdown>
                                  </span>
                                  <div className="mt-2 float-end">
                                    <p>
                                      {filteredDevices.length}{" "}
                                      {props.t("found results")}
                                    </p>
                                  </div>
                                </Col>
                              </Row>

                              <Accordion
                                flush
                                open={filtersOpen}
                                toggle={id => {
                                  id === filtersOpen
                                    ? setFiltersOpen("")
                                    : setFiltersOpen(id)
                                }}
                              >
                                <AccordionItem>
                                  <AccordionBody
                                    accordionId="1"
                                    className="mb-3"
                                    style={{
                                      border: "1px solid",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <Row className="mb-3">
                                      <Col className="col-auto">
                                        <span
                                          className="font-size-16 text-primary"
                                          style={{ fontWeight: "500" }}
                                        >
                                          <i className="mdi mdi-filter me-1"></i>
                                          {props.t("Filters")}
                                        </span>
                                      </Col>
                                      <Col>
                                        <Button
                                          color="danger"
                                          outline
                                          size="sm"
                                          onClick={() => {
                                            setStatusFilter([])
                                            setRoomStatusFilter([])
                                            setModelFilter([])
                                            setAndroidVersionFilter([])
                                            setVideoVersionFilter([])
                                            setMonitorVersionFilter([])
                                            setOperatorFilter([])
                                            setLinkedFilter()
                                            setMonitorConnectionFilter()
                                            setIgnoreAlarmFilter()
                                            setDebuggingFilter()
                                            setExtSpeakerFilter()
                                          }}
                                        >
                                          <i className="mdi mdi-close me-1"></i>
                                          {props.t("Clear")}
                                        </Button>
                                      </Col>
                                    </Row>

                                    <Row xs={1} sm={2} md={3} xl={4}>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Device status")}
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={statusFilter}
                                          onChange={v => {
                                            setStatusFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: "0",
                                              label: props.t("Device on"),
                                            },
                                            {
                                              value: "1",
                                              label: props.t("Charging"),
                                            },
                                            {
                                              value: "2",
                                              label: props.t("Discharging"),
                                            },
                                            {
                                              value: "3",
                                              label: props.t("Shutdown"),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t(
                                            "Video number status"
                                          )}
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={roomStatusFilter}
                                          onChange={v => {
                                            setRoomStatusFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: 0,
                                              label: props.t("Offline"),
                                            },
                                            {
                                              value: "off15",
                                              label:
                                                props.t("Offline") +
                                                " (" +
                                                props.t("over") +
                                                " 15min)",
                                            },
                                            {
                                              value: 1,
                                              label: props.t("Online"),
                                            },
                                            {
                                              value: 2,
                                              label: props.t("Video call"),
                                            },
                                            {
                                              value: 3,
                                              label: props.t("Group call"),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Model")}
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={modelFilter}
                                          onChange={v => {
                                            setModelFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: "SM-T515",
                                              label: props.t(
                                                "Galaxy Tab A (SM-T515)"
                                              ),
                                            },
                                            {
                                              value: "SM-T505",
                                              label: props.t(
                                                "Galaxy Tab A7 (SM-T505)"
                                              ),
                                            },
                                            {
                                              value: "SM-X205",
                                              label: props.t(
                                                "Galaxy Tab A8 (SM-X205)"
                                              ),
                                            },
                                            {
                                              value: "SM-X216B",
                                              label: props.t(
                                                "Galaxy Tab A9 (SM-X216B)"
                                              ),
                                            },
                                            {
                                              value: "SM-X236B",
                                              label: props.t(
                                                "Galaxy Tab A11+ (SM-X236B)"
                                              ),
                                            },
                                            {
                                              value: "HMD T21",
                                              label: props.t("HMD T21"),
                                            },
                                            {
                                              value: "TB330XU",
                                              label:
                                                props.t("Lenovo (TB330XU)"),
                                            },
                                            {
                                              value: "Nokia T21",
                                              label: props.t("Nokia T21"),
                                            },
                                            {
                                              value: "undefined",
                                              label: props.t("Undefined"),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={
                                            "Android " + props.t("version")
                                          }
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={androidVersionFilter}
                                          onChange={v => {
                                            setAndroidVersionFilter(v)
                                          }}
                                          options={[
                                            ...(foundAndroidVersions?.length > 0
                                              ? foundAndroidVersions.map(v => ({
                                                  value: v,
                                                  label: "Android " + v,
                                                }))
                                              : []),
                                            ...[
                                              {
                                                value: "",
                                                label:
                                                  props.t("Unknown") +
                                                  " " +
                                                  props.t("Android"),
                                              },
                                            ],
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={
                                            "Video " + props.t("version")
                                          }
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={videoVersionFilter}
                                          onChange={v => {
                                            setVideoVersionFilter(v)
                                          }}
                                          options={[
                                            ...(foundVideoVersions?.length > 0
                                              ? foundVideoVersions.map(v => ({
                                                  value: v,
                                                  label: v,
                                                }))
                                              : []),
                                            ...[
                                              {
                                                value: "",
                                                label:
                                                  props.t("Unknown") +
                                                  " " +
                                                  props.t("Video"),
                                              },
                                            ],
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={
                                            "Monitor " + props.t("version")
                                          }
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={monitorVersionFilter}
                                          onChange={v => {
                                            setMonitorVersionFilter(v)
                                          }}
                                          options={[
                                            ...(foundMonitorVersions?.length > 0
                                              ? foundMonitorVersions.map(v => ({
                                                  value: v,
                                                  label: v,
                                                }))
                                              : []),
                                            ...[
                                              {
                                                value: "",
                                                label:
                                                  props.t("Unknown") +
                                                  " " +
                                                  props.t("Monitor"),
                                              },
                                            ],
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Links")}
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={linkedFilter}
                                          onChange={v => {
                                            setLinkedFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: "1",
                                              label: props.t("Linked"),
                                            },
                                            {
                                              value: "2",
                                              label: props.t("Not linked"),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Operator")}
                                          mode="multiple"
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={operatorFilter}
                                          onChange={v => {
                                            setOperatorFilter(v)
                                          }}
                                          options={[
                                            { value: "DNA", label: "DNA" },
                                            { value: "Elisa", label: "Elisa" },
                                            { value: "Telia", label: "Telia" },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={
                                            "Monitor " + props.t("connection")
                                          }
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={monitorConnectionFilter}
                                          onChange={v => {
                                            setMonitorConnectionFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: "connected",
                                              label:
                                                props.t("Connected") +
                                                " (" +
                                                props.t("under") +
                                                " 30min)",
                                            },
                                            {
                                              value: "disconnected",
                                              label:
                                                props.t("Disconnected") +
                                                " (" +
                                                props.t("over") +
                                                " 30min)",
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t(
                                            "External speaker"
                                          )}
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={extSpeakerFilter}
                                          onChange={v => {
                                            setExtSpeakerFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: true,
                                              label:
                                                props.t("External speaker") +
                                                " " +
                                                props
                                                  .t("Enabled")
                                                  .toLowerCase(),
                                            },
                                            {
                                              value: false,
                                              label:
                                                props.t("External speaker") +
                                                " " +
                                                props
                                                  .t("Disabled")
                                                  .toLowerCase(),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Ignore alarms")}
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={ignoreAlarmFilter}
                                          onChange={v => {
                                            setIgnoreAlarmFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: true,
                                              label:
                                                props.t("Ignore alarms") +
                                                " " +
                                                props
                                                  .t("Enabled")
                                                  .toLowerCase(),
                                            },
                                            {
                                              value: false,
                                              label:
                                                props.t("Ignore alarms") +
                                                " " +
                                                props
                                                  .t("Disabled")
                                                  .toLowerCase(),
                                            },
                                          ]}
                                        />
                                      </Col>
                                      <Col className="mb-3">
                                        <Select
                                          placeholder={props.t("Debugging")}
                                          allowClear
                                          style={{ width: "100%" }}
                                          value={debuggingFilter}
                                          onChange={v => {
                                            setDebuggingFilter(v)
                                          }}
                                          options={[
                                            {
                                              value: true,
                                              label:
                                                props.t("Debugging") +
                                                " " +
                                                props
                                                  .t("Enabled")
                                                  .toLowerCase(),
                                            },
                                            {
                                              value: false,
                                              label:
                                                props.t("Debugging") +
                                                " " +
                                                props
                                                  .t("Disabled")
                                                  .toLowerCase(),
                                            },
                                          ]}
                                        />
                                      </Col>
                                    </Row>
                                  </AccordionBody>
                                </AccordionItem>
                              </Accordion>

                              <Row className="mt-1">
                                <Col xl="12">
                                  <AntdTable
                                    className="colored-header narrow-header"
                                    bordered
                                    size="small"
                                    rowKey={"serial"}
                                    columns={columns}
                                    dataSource={filteredDevices}
                                    rowSelection={{
                                      type: "radio",
                                      fixed: false,
                                      selectedRowKeys: selectedRowKeys,
                                      onChange: onSelectChange,
                                      columnWidth: 0,
                                      renderCell: () => "",
                                    }}
                                    onRow={(record, rowIndex) => {
                                      return {
                                        onClick: event => {
                                          if (
                                            selectedRowKeys.includes(
                                              record.serial
                                            )
                                          ) {
                                            setSelectedRowKeys([])
                                          } else {
                                            setSelectedRowKeys([record.serial])
                                          }
                                        },
                                      }
                                    }}
                                    pagination={{
                                      showSizeChanger: true,
                                      defaultPageSize: 50,
                                      pageSizeOptions: defaultPageSizeOptions,
                                    }}
                                    loading={ongoingSearch}
                                    tableLayout="auto"
                                    scroll={{
                                      x: "max-content",
                                      y: tableDefaultHeight,
                                    }}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane className="show" tabId="2">
                      <Table
                        style={{ tableLayout: "fixed" }}
                        className="table"
                        bordered={false}
                        striped={false}
                        hover={true}
                      >
                        <thead>
                          <tr>
                            <th></th>
                            <th>{props.t("Count")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">{props.t("Devices")}</th>
                            <td>{statistics.total}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Linked")}</th>
                            <td>{statistics.linked}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Charging")}</th>
                            <td>{statistics.charging}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Discharging")}</th>
                            <td>{statistics.discharging}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Shutdown")}</th>
                            <td>{statistics.shutdown}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Galaxy Tab A")}</th>
                            <td>{statistics.tabA}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Galaxy Tab A7")}</th>
                            <td>{statistics.tabA7}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Galaxy Tab A8")}</th>
                            <td>{statistics.tabA8}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Galaxy Tab A9")}</th>
                            <td>{statistics.tabA9}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Galaxy Tab A11+")}</th>
                            <td>{statistics.tabA11Plus}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Nokia T21")}</th>
                            <td>{statistics.nokiaT21}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("HMD T21")}</th>
                            <td>{statistics.hmdT21}</td>
                          </tr>
                          <tr>
                            <th scope="row">{props.t("Unknown model")}</th>
                            <td>{statistics.unknownModel}</td>
                          </tr>
                          {Object.keys(androidVersions).map((entry, index) => (
                            <tr key={"" + index}>
                              <th scope="row">{"Android " + entry}</th>
                              <td>{androidVersions[entry]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/** Device settings drawer */}
          <VideoDeviceDrawer
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            selectedRow={selectedRow}
            getDevices={getDevices}
          />

          {/** Import devices modal */}
          <Modal
            isOpen={addModal}
            toggle={() => {
              setAddModal(!addModal)
            }}
            centered
          >
            <Form
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalHeader>{props.t("Add devices")}</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label>{props.t("Serials")}</Label>
                  <AntdForm.Item
                    validateStatus={
                      addValidation.errors.serialList ? "error" : ""
                    }
                    hasFeedback
                    help={addValidation.errors.serialList}
                  >
                    <TextArea
                      allowClear
                      rows={5}
                      placeholder={"serial1, serial2, serial3..."}
                      value={addValidation.values.serialList}
                      onChange={v => {
                        addValidation.setFieldValue(
                          "serialList",
                          v.target.value
                        )
                      }}
                    />
                  </AntdForm.Item>
                </FormGroup>
                <FormGroup>
                  <Label>{props.t("Order number")}</Label>
                  <SelectOrder
                    selection={addValidation.values.orderNumber}
                    setSelectedOrder={v => {
                      addValidation.setFieldValue("orderNumber", v)
                    }}
                  />
                </FormGroup>
                <FormGroup className="mt-4">
                  <Switch
                    className="me-2"
                    name="ignoreAlarms"
                    checked={addValidation.values.ignoreAlarms}
                    onChange={v =>
                      addValidation.setFieldValue("ignoreAlarms", v)
                    }
                  />
                  <Label>{props.t("Ignore alarms")}</Label>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setAddModal(false)
                    //setSerialList("")
                    addValidation.resetForm()
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  disabled={
                    addValidation.values.serialList.length == 0 || ongoingAdd
                  }
                  color="success"
                  onClick={() => {
                    addValidation.submitForm()
                  }}
                >
                  {props.t("Add")}
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/** Set settings by order modal */}
          <Modal
            isOpen={orderSettingModal}
            toggle={() => {
              setOrderSettingModal(!orderSettingModal)
            }}
            centered
          >
            <Form
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalHeader>{props.t("Set ignore alarms")}</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label>{props.t("Order number")}</Label>
                  <SelectOrder
                    selection={orderSettingsValidation.values.orderNumber}
                    setSelectedOrder={v => {
                      orderSettingsValidation.setFieldValue("orderNumber", v)
                    }}
                  />
                  {!orderSettingsValidation.values.orderNumber ? (
                    <FormText color="danger">
                      {props.t("Required field")}
                    </FormText>
                  ) : null}
                </FormGroup>
                <FormGroup className="mt-4">
                  <Switch
                    className="me-2"
                    name="ignoreAlarms"
                    checked={orderSettingsValidation.values.ignoreAlarms}
                    onChange={v =>
                      orderSettingsValidation.setFieldValue("ignoreAlarms", v)
                    }
                  />
                  <Label>{props.t("Ignore alarms")}</Label>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setOrderSettingModal(false)
                    orderSettingsValidation.resetForm()
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  disabled={
                    ongoingAdd || !orderSettingsValidation.values.orderNumber
                  }
                  color="primary"
                  onClick={() => {
                    orderSettingsValidation.submitForm()
                  }}
                >
                  {props.t("Set")}
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/** Device status history modal - only devices that have debugging enabled */}
          <Modal
            isOpen={deviceHistoryModal}
            toggle={() => {
              setDeviceHistoryModal(!deviceHistoryModal)
            }}
            centered
            size="xl"
          >
            <ModalHeader
              toggle={() => {
                setDeviceHistoryModal(!deviceHistoryModal)
              }}
            >
              {props.t("History") +
                ": " +
                selectedRow?.serial +
                " / " +
                selectedRow?.imei}
            </ModalHeader>
            <ModalBody>
              <VideoDeviceHistory serial={selectedRow?.serial} />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  )
}

VideoDevices.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(VideoDevices)
